import { FC } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import MainContainer from '../components/ui_components/MainContainer';
import ButtonCategoryComponent from '../components/home_components/ButtonCategoryComponent';
import listCategory from '../components/home_components/ListCategoryJson';
import NewsFeed from '../components/home_components/NewsFeed';
import CardPodium from '../components/home_components/CardPodium';
import ChampionsSection from '../components/home_components/ChampionsSection';
import RecentPpvsSection from '../components/home_components/RecentPpvsSection';
import useResponsiveRedux from '../components/Hooks/useResponsiveRedux';
import MobileHomePageRender from '../components/MobileComponents/HomePage/MobileHomePageRender';
import colors from '../styles/colors';

const Container = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding-bottom: 50px;

  & p.description-text {
    font-weight: 700;
    color: white;
    margin: 20px 0;
    padding: 0;
    width: 40%;
    text-align: center;
    font-family: CameronSansMedium;
    font-size: 18px;
    letter-spacing: 3px;
  }
`;

const ContainerButtonCategory = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  row-gap: 50px;
  column-gap: 50px;
  width: 90%;
  height: 100%;

  & > * {
    max-width: 200px;
  }

  & .wi-100 {
    width: 100%;
    max-width: 100%;
  }
`;

const SectionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 90%;
  margin-bottom: 22px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
  }
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.16em;
  white-space: nowrap;
`;

const FooterInfoSection = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  background-color: ${colors.bgColorBlack2};
  color: white;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  display: flex;
  justify-content: end;
  align-items: center;

  & .footer-info-text {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding-right: 20px;
    letter-spacing: 1px;
  }

  & .footer-info-linkedin-icon {
    width: 15px;
    height: 15px;
    margin: 0 5px;
  }
`;

interface CategoryItem {
  title: string;
  img: string;
  link: string;
}

const HomePage: FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useResponsiveRedux();

  const navigateToPage = (page: string): void => {
    navigate(page);
  };

  return isMobile ? (
    <MainContainer isMobile={isMobile}>
      <MobileHomePageRender listCategory={listCategory} />
    </MainContainer>
  ) : (
    <MainContainer>
      <Container className="container-home-page">
        <p className="description-text">
          La{' '}
          <a
            href="https://gwf.forumcommunity.net/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Global Wrestling Federation
          </a>{' '}
          è una eFed (Gioco di ruolo narrativo) nata nel 2005 e che continua ancora oggi ad
          essere attiva. Questo sito vuole raccogliere tutti i dati relativi a questo mondo,
          dando un interfaccia grafica a quanto presente nel forum.
        </p>

        <CardPodium />
        <NewsFeed />

        <ChampionsSection />

        <RecentPpvsSection />

        <SectionHeading>
          <SectionTitle>Esplora</SectionTitle>
        </SectionHeading>

        <ContainerButtonCategory className="container-button-category">
          {(listCategory as CategoryItem[]).map((category, index) => (
            <ButtonCategoryComponent
              key={index}
              title={category.title}
              img={category.img}
              onClick={() => navigateToPage(category.link)}
            />
          ))}
        </ContainerButtonCategory>

        <FooterInfoSection className="footer-info-section">
          <p className="footer-info-text">
            Realizzato da
            <img
              src={process.env.REACT_APP_STORAGE_URL + 'img/utilities/LogoLinkedin.png'}
              alt="Linkedin Icon"
              className="footer-info-linkedin-icon"
            />
            <a
              href="https://www.linkedin.com/in/simone-pancione-733152231/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Simone Pancione
            </a>
          </p>
        </FooterInfoSection>
      </Container>
    </MainContainer>
  );
};

export default HomePage;
